import LightGallery from 'lightgallery/react';
import './Gal.css';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-fullscreen.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-rotate.css';


// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgAutoplay from 'lightgallery/plugins/autoplay'
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgShare from 'lightgallery/plugins/share';
import lgRotate from 'lightgallery/plugins/rotate';

const images = [
    { src: "images/3d web/3d (2).jpg", alt: "1" },
    { src: "images/3d web/3d (3).jpg", alt: "2" },
    { src: "images/3d web/3d (1).png", alt: "3" },
    { src: "images/3d web/3d (2).png", alt: "4" },
    { src: "images/3d web/3d (1).jpg", alt: "5" },
    { src: "images/3d web/3d (3).png", alt: "6" },
    { src: "images/3d web/3d (4).jpg", alt: "7" },
    { src: "images/3d web/3d (4).png", alt: "8" },
    { src: "images/3d web/3d (5).jpg", alt: "9" },
    { src: "images/3d web/3d (5).png", alt: "10" },
    { src: "images/3d web/3d (6).jpg", alt: "11" },
    { src: "images/3d web/3d (6).png", alt: "12" },
    { src: "images/3d web/3d (7).jpg", alt: "13" },
    { src: "images/3d web/3d (7).png", alt: "14" },
    { src: "images/3d web/3d (8).jpg", alt: "15" },
    { src: "images/3d web/3d (8).png", alt: "16" },
    { src: "images/3d web/3d (9).png", alt: "17" },
    { src: "images/3d web/3d (9).jpg", alt: "18" },
    { src: "images/3d web/3d (10).png", alt: "19" },
    { src: "images/3d web/3d (10).jpg", alt: "20" },
    { src: "images/3d web/3d (11).png", alt: "21" },
    { src: "images/3d web/3d (11).jpg", alt: "22" },
    { src: "images/3d web/3d (12).jpg", alt: "23" },
    { src: "images/3d web/3d (12).png", alt: "24" },
    { src: "images/3d web/3d (13).png", alt: "25" },
    { src: "images/3d web/3d (13).jpg", alt: "26" },
    { src: "images/3d web/3d (14).jpg", alt: "27" },
    { src: "images/3d web/3d (15).jpg", alt: "28" },
    { src: "images/3d web/3d (16).jpg", alt: "29" },
    { src: "images/3d web/3d (17).jpg", alt: "30" },
    { src: "images/3d web/3d (18).jpg", alt: "31" },
    { src: "images/3d web/3d (19).jpg", alt: "32" },
    { src: "images/3d web/3d (20).jpg", alt: "33" },
    { src: "images/3d web/3d (21).jpg", alt: "34" },
    { src: "images/3d web/3d (22).jpg", alt: "35" },
    { src: "images/3d web/3d (23).jpg", alt: "36" },
    { src: "images/3d web/3d (24).jpg", alt: "37" },
    { src: "images/3d web/3d (25).jpg", alt: "38" },
    { src: "images/3d web/3d (26).jpg", alt: "39" },
    { src: "images/3d web/3d (27).jpg", alt: "40" },
    { src: "images/3d web/3d (28).jpg", alt: "41" },
    { src: "images/3d web/3d (29).jpg", alt: "42" },
    { src: "images/3d web/3d (30).jpg", alt: "43" },
    { src: "images/3d web/3d (31).jpg", alt: "44" },
    { src: "images/3d web/3d (32).jpg", alt: "45" },
    { src: "images/3d web/3d (33).jpg", alt: "46" },
    { src: "images/3d web/3d (34).jpg", alt: "47" },
    { src: "images/3d web/3d (35).jpg", alt: "48" },
    { src: "images/3d web/3d (36).jpg", alt: "49" },
    { src: "images/3d web/3d (37).jpg", alt: "50" },
    { src: "images/3d web/3d (38).jpg", alt: "51" },
    { src: "images/Ba07/BA 7 (15).jpg", alt: "52" },
    { src: "images/Ba07/BA 7 (1).jpg", alt: "53" },
    { src: "images/Ba17/BA 17 (1).jpg", alt: "54" },
    { src: "images/Ba19/BA 19 (1).jpg", alt: "55" },
    { src: "images/Ba19/BA 19 (2).jpg", alt: "56" },
    { src: "images/Ba19/BA 19 (3).jpg", alt: "57" },
    { src: "images/Ba20/BA 20 (1).jpg", alt: "58" },
    { src: "images/Ba20/BA 20 (2).jpg", alt: "59" },
    { src: "images/Ba21/BA 21 (1).jpg", alt: "60" },
    { src: "images/Ba21/BA 21 (2).jpg", alt: "61" },
    { src: "images/Ba21/BA 21 (3).jpg", alt: "62" },
    { src: "images/Ba21/BA 21 (4).jpg", alt: "63" },
    { src: "images/Ba21/BA 21 (5).jpg", alt: "64" },
    { src: "images/Ba21/BA 21 (6).jpg", alt: "65" },
    { src: "images/Ba21/BA 21 (7).jpg", alt: "66" },
    { src: "images/Ba21/BA 21 (8).jpg", alt: "67" },
    { src: "images/Ba25/BA 25 (1).jpg", alt: "68" },
    { src: "images/Ba25/BA 25 (2).jpg", alt: "69" },
    { src: "images/Ba29/BA 29 (6).jpg", alt: "70" },
    { src: "images/Ba29/BA 29 (16).jpg", alt: "71" },
    { src: "images/Ba29/BA 29 (17).jpg", alt: "72" },
    { src: "images/Ba29/BA 29 (18).jpg", alt: "73" },
    { src: "images/Ba29/BA 29 (19).jpg", alt: "74" },
 
 
]

function Gal() {
    const onInit = () => {
        console.log('lightGallery has been initialized');
    };
    return (
        <div className="gallery-container">
        <h1>Architecture</h1>
       <p className='about'> Our architecture services focus on creating innovative and functional designs that meet our clients' needs while enhancing the structural integrity of each project. We blend creativity with technical expertise to deliver visionary solutions.
       </p>  
            <LightGallery
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom, lgAutoplay, lgFullscreen, lgRotate, lgShare]}
            >

                {images.map((image, index) => {
                    return (
                        <a href={image.src} key={index}>
                            <img alt={image.alt} src={image.src} />
                        </a>
                    )
                })}


            </LightGallery>
        </div>
    );
}
export default Gal;
